<template>
    <div class="mt-6 w-full rounded-2xl bg-white p-6">
        <div class="flex items-center justify-between gap-2">
            <div class="text-sm text-slate-800">
                Do you want to reserve this date?
            </div>
            <vx-toggle
                size="sm"
                :disabled="props.disabled"
                v-model="enabled"
                data-test="reserve-date-toggle"
            />
        </div>

        <template v-if="enabled">
            <div class="mt-4 flex items-center justify-between gap-2">
                <div class="text-sm">
                    Block <strong>{{ otherTypeLabel }}</strong> as well?
                </div>
                <vx-toggle
                    size="sm"
                    :disabled="props.disabled"
                    v-model="blockOtherType"
                    data-test="reserve-date-block-other-type-toggle"
                />
            </div>

            <vx-alert :closeable="false" color="slate" class="mt-4">
                <strong>Existing Blasts for this date will remain.</strong>
                New Blasts from Groups and OUs cannot choose this date.
            </vx-alert>

            <div class="mt-4">
                <vx-label>
                    <div class="flex items-center gap-2">
                        <span>Reason</span>
                        <vx-badge color="violet" size="xs">
                            <span class="pb-[1.5px] text-xs leading-snug">Optional</span>
                            <font-awesome-icon widthAuto :icon="faPencilSlash" size="xs" />
                        </vx-badge>
                    </div>
                </vx-label>
                <vx-input
                    v-model="reason"
                    :rows="2"
                    :maxlength="80"
                    :counter="true"
                    :disabled="props.disabled"
                    data-test="reserve-date-reason"
                />
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
import {
    VxAlert,
    VxBadge,
    VxInput,
    VxLabel,
    VxToggle,
} from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { computed, watch } from 'vue';
import { AUDIENCE_TYPE_MARKETING } from '~/constants/campaign';

const props = defineProps<{
    disabled?: boolean;
    campaignType?: string;
}>();

const enabled = defineModel<boolean>('enabled', { default: false });
const reason = defineModel<string>('reason', { default: '' });
const blockOtherType = defineModel<boolean>('blockOtherType', { default: false });

const otherTypeLabel = computed(() => {
    return props.campaignType === AUDIENCE_TYPE_MARKETING ? 'Transactional' : 'Marketing';
});

watch(() => props.campaignType, () => {
    blockOtherType.value = false;
});
</script>
